<template>
  <div>
    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="isLoggedIn" @click="onLogout">
          <v-list-item-title>
            <v-icon>mdi-logout</v-icon>Logout
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isLoggedIn" @click="onProfile">
          <v-list-item-title>
            <v-icon>mdi-account-cog</v-icon>Profile
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isLoggedIn" @click="onHome">
          <v-list-item-title>
            <v-icon>mdi-home</v-icon>Home
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn" @click="onLogin">
          <v-list-item-title>
            <v-icon>mdi-login</v-icon>Login
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn" @click="onRegister">
          <v-list-item-title>
            <v-icon>mdi-account-plus</v-icon>Register
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn" @click="onResetPassword">
          <v-list-item-title>
            <v-icon>mdi-lock-reset</v-icon>Reset Password
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn" @click="onForgotUsername">
          <v-list-item-title>
            <v-icon>mdi-account-question-outline</v-icon>Forgot Username
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import router from '@/router/index.js'

export default {
  name: 'authentication',

  components: {},

  data: () => ({}),

  computed: {
    isLoggedIn() {
      return this.$store.getters.getLoggedIn
    }
  },

  methods: {
    onForgotUsername() {
      router.push('/account/forgot')
    },
    onHome() {
      router.push('/account/home')
    },
    onLogout() {
      router.push('/account/logout')
    },
    onLogin() {
      router.push('/account/login')
    },
    onProfile() {
      router.push('/account/profile')
    },
    onRegister() {
      router.push('/account/register')
    },
    onResetPassword() {
      router.push('/account/reset')
    }
  }
}
</script>
